import forgotCredentialsModule from '../forgotCredentialsModule';

function forgotCredentials(forgotCredentialsConstants) {
    "ngInject";

    return {
        restrict: "A",
        replace: false,
        templateUrl: forgotCredentialsConstants.templates.forgotCredentials
    }
}

forgotCredentialsModule.directive("forgotCredentials", forgotCredentials);

export default forgotCredentials;